import { render, staticRenderFns } from "./add-video.vue?vue&type=template&id=6b540a10&"
import script from "./add-video.vue?vue&type=script&lang=js&"
export * from "./add-video.vue?vue&type=script&lang=js&"
import style0 from "./add-video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports